import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteBankAdditionalInstallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/deleteBankAdditionalInstallment/',
      requesterInfo,
    })
  }

  public async deleteBankAdditionalInstallment(id: number): Promise<any> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<any>()
  }
}
